import Divider from 'core-system/Divider'
import React from 'react'
import styled from 'styled-components'

const SectionContainer = styled.div<{ isLastSection: boolean }>`
  ${({ isLastSection }) => !isLastSection && `margin-bottom: 1.5rem;`}
`

interface ProgramEditingSubSectionProps {
  children: React.ReactNode
  isLastSection?: boolean
}

const ProgramEditingSubSection = ({
  children,
  isLastSection = false,
}: ProgramEditingSubSectionProps) => {
  return (
    <SectionContainer isLastSection={isLastSection}>
      {children}
      {!isLastSection && <Divider marginTop='1.75rem' />}
    </SectionContainer>
  )
}

export default React.memo(ProgramEditingSubSection)
